import { create } from "zustand";

import {
  InitializePaginationProperties,
  InitializeSetPaginationProperties,
  PaginationProperties,
  SetPaginationProperties
} from "../../../../../common/utils/pagination_property";


type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useTermoEpiListaPagination = create<State & Actions>((set, get) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));